import { Button, Form } from '@heroui/react'
import type { User } from '@qse/constants'
import { validatePassword, validatePasswordConfirmation } from '@qse/constants'
import { HeroInput } from '@qse/ui'
import { storage } from '@qse/utils'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useSetNewPassword } from '../logic'

interface SetNewPasswordScreenProps {
  onSuccess?: (response: User) => void
}

const NewPasswordScreen: React.FC<SetNewPasswordScreenProps> = () => {
  const { handleSetNewPassword } = useSetNewPassword()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  useEffect(() => {
    const tempEmail = storage.localStorage.getItem('temp_email')

    if (!tempEmail) {
      navigate('/auth/login', { replace: true })
    }
  }, [navigate])

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setIsLoading(true)

    const values = {
      password,
      confirmPassword,
    }

    handleSetNewPassword(values, {
      setSubmitting: setIsLoading,
      onTOTPSetupRequired: (_totpSetup: unknown, _isFirstLogin?: boolean) => {
        // This will be handled by the hook, but we can add custom logic here if needed
      },
      onTOTPCodeRequired: () => {
        // This will be handled by the hook, but we can add custom logic here if needed
      },
    })
  }

  return (
    <div className="h-full">
      <div className="flex items-center h-[calc(100vh-72px)] w-full lg:pl-[110px] lg:max-w-full max-w-[440px] mx-auto">
        <div className="lg:w-[440px] w-full p-8 lg:p-0 flex flex-col gap-11">
          <div className="flex flex-col gap-2">
            <h1 className="text-[28px] font-medium">Change Your Password</h1>
            <p className="text-[15px]">
              For security reasons, you must change your temporary password before accessing your
              account.
            </p>
          </div>

          <Form className="w-full" validationBehavior="native" onSubmit={handleSubmit}>
            <div className="w-full">
              <div className="flex flex-col gap-[30px]">
                <HeroInput
                  isRequired
                  control="password"
                  label="New Password"
                  name="password"
                  placeholder="Enter new password"
                  radius="sm"
                  size="md"
                  validate={validatePassword}
                  value={password}
                  variant="bordered"
                  onChange={setPassword}
                />
                <HeroInput
                  isRequired
                  control="password"
                  label="Confirm New Password"
                  name="confirmPassword"
                  placeholder="Confirm new password"
                  radius="sm"
                  size="md"
                  validate={validatePasswordConfirmation(password)}
                  value={confirmPassword}
                  variant="bordered"
                  onChange={setConfirmPassword}
                />
              </div>
              <Button
                className="w-full mt-5 font-medium"
                color="primary"
                isLoading={isLoading}
                radius="sm"
                type="submit"
              >
                Set New Password
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  )
}

export default NewPasswordScreen
